import styled from "styled-components";

import { TAB_BAR } from "../../constants/tabBar";
import { fontSizes } from "../../shared/styles/typography";
import { tokens } from "../../theme/tokens";

const BP = tokens.layout.mobileFirstExpandPx;

export const PageBody = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SearchBox = styled.div`
  background: #fff;
  border-radius: 16px;
  border: 2px solid #eaecef;
  padding: 4px 4px 4px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus-within {
    border-color: ${TAB_BAR.primary};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  input {
    flex: 1;
    border: none;
    outline: none;
    font-size: ${fontSizes.base}px;
    padding: 12px 0;
    background: transparent;
    color: var(--color-text-title);
  }
`;

export const Hint = styled.p`
  font-size: ${fontSizes.sm}px;
  color: ${TAB_BAR.secondary};
  line-height: 1.4;
`;

export const ListWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: ${BP}px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  @media (min-width: 1200px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const EmptyHint = styled.div`
  text-align: center;
  padding: 32px 16px;
  color: ${TAB_BAR.secondary};
  font-size: ${fontSizes.sm}px;
`;
